import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AppConfig, CMPS_APP_CONFIG } from '../../app.config';
import { catchErrorLogRet } from '../../common/rest.operators';

import { Voice } from './model/voice.model';

@Injectable()
export class VoiceService {
    constructor(
        private readonly _http: HttpClient,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    upsert(voice: Voice): Observable<void> {
        return this._http
            .put(
                `${this._appConfig.API_ENDPOINTS.LOCAL_CALL}/users/${voice.userId}/voice`,
                voice,
            )
            .pipe(catchErrorLogRet());
    }
}
